// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBVknuy7Gdz8iwYufUnmo6PO12VIb6ggNo",
  authDomain: "fixit-prod-141b2.firebaseapp.com",
  databaseURL: "https://fixit-prod-141b2.firebaseio.com",
  projectId: "fixit-prod-141b2",
  storageBucket: "fixit-prod-141b2.appspot.com",
  messagingSenderId: "562168156698",
  appId: "1:562168156698:web:a9c4243ee02db43e89f7a3",
  measurementId: "G-8SK4K4RWTK"
};

const firebaseConfigQA = {
  apiKey: "AIzaSyAuLglzZraJRhVN0zL4gjj7bv163OQmZHU",
  authDomain: "fixit-qa.firebaseapp.com",
  databaseURL: "https://fixit-qa.firebaseio.com",
  projectId: "fixit-qa",
  storageBucket: "fixit-qa.appspot.com",
  messagingSenderId: "313587590162", 
  appId: "1:313587590162:web:0a4ba03d5dee6b105d24cb",
  measurementId: "G-RYBN8HZQEX"
};

// let env = 'PROD';

let env = process.env.REACT_APP_FRONT_ENV || 'PROD';
console.log('FirebaseEnv', env)

let finalConfig = firebaseConfig;

switch (env) {
  case 'PROD':
    finalConfig = firebaseConfig;
    break
  case 'QA':
    finalConfig = firebaseConfigQA;
    break
  case 'LOCAL':
    finalConfig = firebaseConfig;
    console.warn("Using default firebase config for prod in LOCAL, use whichever one you like")
    break
  default:
    finalConfig = firebaseConfig;
    break
}


// Initialize Firebase
export const firebaseApp = initializeApp(finalConfig);
export const firebaseAuth = getAuth(firebaseApp);

